// import React, { useState, useEffect, useRef } from "react";
// import Api from "../Utills/Api";
// import { motion } from "framer-motion";
// import { QRCodeCanvas } from "qrcode.react";
// import "./Profile.css";

// const MyProfile = () => {
//   const [email, setEmail] = useState("");
//   const [name, setName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [location, setLocation] = useState("");
//   const [profileImage, setProfileImage] = useState(null);
//   const [photo, setPhoto] = useState("");
//   const [influencerRecord, setInfluencerRecord] = useState(null);
//   const referral_code = localStorage.getItem("referral_code");
//   const referralLink = referral_code
//   ? ` https://frozenwala.com/signup?referral_code=${referral_code}`
//   : "No referral code assigned";
//   const qrCodeUrl = "https://play.google.com/store/apps/details?id=com.frozenwala.app&pcampaignid=web_share";
//   const qrCanvasRef = useRef(null);

//   useEffect(() => {
//     const getProfile = async () => {
//       const uid = localStorage.getItem("user_id");

//       try {
//         const response = await Api.get(`api/profile/?user_id=${uid}`);
//         //  localStorage.setItem("wallet", response.data.walet);
//         setPhoto(response.data.profile_photo);
//         setEmail(response.data.email);
//         setName(response.data.name);
//         setPhone(response.data.phone_number);
//         setLocation(response.data.bio);
//         setInfluencerRecord(response.data.influencer_record || null);
//       } catch (error) {
//         console.log("Error fetching profile:", error);
//       }
//     };
//     getProfile();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const uid = localStorage.getItem("user_id");
//     try {
//       const formData = new FormData();
//       formData.append("name", name);
//       formData.append("user_id", uid);
//       formData.append("email", email);
//       formData.append("phone_number", phone);
//       formData.append("bio", location);
//       if (profileImage) formData.append("profile_photo", profileImage);

//       const response = await Api.post(`api/profile/`, formData);
//       console.log("Profile updated:", response.data);
//       window.location.reload();
//     } catch (error) {
//       console.log("Error updating profile:", error.response?.data);
//     }
//   };

//   const downloadQRCode = () => {
//     if (!qrCodeUrl) return;

//     const canvas = qrCanvasRef.current.querySelector("canvas");
//     const pngUrl = canvas
//       .toDataURL("image/png")
//       .replace("image/png", "image/octet-stream");

//     const downloadLink = document.createElement("a");
//     downloadLink.href = pngUrl;
//     downloadLink.download = "frozenwala-app-qr.png";
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     document.body.removeChild(downloadLink);
//   };

//   return (
//     <div className="my-profile-container">
//       <motion.div
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className="my-profile-card"
//       >
//         <h2 className="my-profile-title">
//           My Profile
//         </h2>

//         <div className="profile-image-container">
//           <img
//             src={profileImage ? URL.createObjectURL(profileImage) : photo || "/img/gallery/akash.jpeg"}
//             alt="Profile"
//             className="profile-image"
//           />
//         </div>
//         {/* Download & Share Section */}
//         {qrCodeUrl && (
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//             style={{
//               backgroundColor: "#fff",
//               borderRadius: "16px",
//               padding: "24px",
//               marginTop: "30px",
//               marginBottom: "30px",
//               boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
//               border: "1px solid #f0f0f0",
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "30px",
//               alignItems: "center"
//             }}
//           >
//             {/* Left Side - Information */}
//             <div style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "16px"
//             }}>
//               {/* Referral Code Section */}
//               <div style={{
//                 padding: "14px 16px",
//                 backgroundColor: "#f8f8f8",
//                 borderRadius: "10px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "12px",
//                 border: "1px solid #e8e8e8"
//               }}>
//                 <div style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "flex-start",
//                   flex: 1
//                 }}>
//                   <span style={{
//                     fontSize: "12px",
//                     color: "#999",
//                     fontWeight: "500",
//                     marginBottom: "4px"
//                   }}>
//                     Your Referral Code
//                   </span>
//                   <span style={{
//                     fontSize: "18px",
//                     fontWeight: "700",
//                     color: "#333",
//                     letterSpacing: "1px"
//                   }}>
//                     {referral_code || "REF000000"}
//                   </span>
//                 </div>
//                 <motion.button
//                   whileTap={{ scale: 0.9 }}
//                   onClick={() => {
//                     navigator.clipboard.writeText(referral_code || "REF000000");
//                     alert("Referral code copied ✅");
//                   }}
//                   style={{
//                     backgroundColor: "#5dc5fa",
//                     color: "#fff",
//                     border: "none",
//                     padding: "8px 12px",
//                     borderRadius: "8px",
//                     fontSize: "12px",
//                     fontWeight: "600",
//                     cursor: "pointer",
//                     flexShrink: 0,
//                     minWidth: "45px"
//                   }}
//                 >
//                   📋
//                 </motion.button>
//               </div>

//               {/* Download Options */}
//               <div style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 gap: "10px"
//               }}>
//                 <a
//                   href="https://frozenwala.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "12px",
//                     borderRadius: "10px",
//                     backgroundColor: "#f5f5f5",
//                     textDecoration: "none",
//                     transition: "all 0.3s ease",
//                     width: "100px",
//                     height: "100px",
//                     overflow: "hidden"
//                   }}
//                   onMouseOver={(e) => {
//                     e.currentTarget.style.backgroundColor = "#eee";
//                     e.currentTarget.style.transform = "translateY(-2px)";
//                   }}
//                   onMouseOut={(e) => {
//                     e.currentTarget.style.backgroundColor = "#f5f5f5";
//                     e.currentTarget.style.transform = "translateY(0)";
//                   }}
//                 >
//                   <span style={{ fontSize: "24px" }}>🌐</span>
//                   <span style={{
//                     fontSize: "12px",
//                     fontWeight: "600",
//                     color: "#333"
//                   }}>
//                     Website
//                   </span>
//                 </a>
//                 <a
//                   href="https://apps.apple.com/app/frozenwala"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "12px",
//                     borderRadius: "10px",
//                     backgroundColor: "#f5f5f5",
//                     textDecoration: "none",
//                     transition: "all 0.3s ease",
//                     width: "100px",
//                     height: "100px",
//                     overflow: "hidden"
//                   }}
//                   onMouseOver={(e) => {
//                     e.currentTarget.style.backgroundColor = "#eee";
//                     e.currentTarget.style.transform = "translateY(-2px)";
//                   }}
//                   onMouseOut={(e) => {
//                     e.currentTarget.style.backgroundColor = "#f5f5f5";
//                     e.currentTarget.style.transform = "translateY(0)";
//                   }}
//                 >
//                   <span style={{ fontSize: "24px" }}>🍎</span>
//                   <span style={{
//                     fontSize: "12px",
//                     fontWeight: "600",
//                     color: "#333"
//                   }}>
//                     iOS App
//                   </span>
//                 </a>
//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.frozenwala.app"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "12px",
//                     borderRadius: "10px",
//                     backgroundColor: "#f5f5f5",
//                     textDecoration: "none",
//                     transition: "all 0.3s ease",
//                     width: "100px",
//                     height: "100px",
//                     overflow: "hidden"
//                   }}
//                   onMouseOver={(e) => {
//                     e.currentTarget.style.backgroundColor = "#eee";
//                     e.currentTarget.style.transform = "translateY(-2px)";
//                   }}
//                   onMouseOut={(e) => {
//                     e.currentTarget.style.backgroundColor = "#f5f5f5";
//                     e.currentTarget.style.transform = "translateY(0)";
//                   }}
//                 >
//                   <span style={{ fontSize: "24px" }}>🤖</span>
//                   <span style={{
//                     fontSize: "12px",
//                     fontWeight: "600",
//                     color: "#333"
//                   }}>
//                     Android App
//                   </span>
//                 </a>
//               </div>
//             </div>

//             {/* Right Side - QR Code (Centered Vertically) */}
//             <motion.div
//               ref={qrCanvasRef}
//               whileHover={{ scale: 1.05 }}
//               style={{
//                 borderRadius: "12px",
//                 padding: "12px",
//                 backgroundColor: "#fff",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 overflow: "hidden"
//               }}
//             >
//               <QRCodeCanvas
//                 value={qrCodeUrl}
//                 size={200}
//                 bgColor="#ffffff"
//                 fgColor="#000000"
//                 level="H"
//               />
//             </motion.div>
//           </motion.div>

//         )}
//           <motion.button
//             whileHover={{ scale: 1.02, boxShadow: "0 6px 24px rgba(255, 152, 0, 0.4)" }}
//             whileTap={{ scale: 0.95 }}
//             onClick={downloadQRCode}
//             style={{
//               backgroundColor: "#e41f26",
//               color: "#fff",
//               border: "none",
//               padding: "14px 28px",
//               borderRadius: "12px",
//               fontWeight: "700",
//               fontSize: "16px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "8px",
//               boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
//               transition: "all 0.3s ease",
//               width: "100%",
//               gridColumn: "1 / -1"
//             }}
//           >
//             🛒 Download & Order Now
//           </motion.button>

//           {/* Referral Link Display */}
//           <div style={{
//             padding: "12px 14px",
//             backgroundColor: "#f9f9f9",
//             borderRadius: "8px",
//             border: "1px solid #e8e8e8",
//             gridColumn: "1 / -1"
//           }}>
//             <div style={{
//               fontSize: "11px",
//               color: "#999",
//               marginBottom: "6px",
//               fontWeight: "500"
//             }}>
//               Your Referral Link:
//             </div>
//             <div style={{
//               display: "flex",
//               gap: "8px",
//               alignItems: "stretch"
//             }}>
//               <input
//                 type="text"
//                 value={referralLink}
//                 readOnly
//                 style={{
//                   flex: 1,
//                   padding: "8px 10px",
//                   borderRadius: "6px",
//                   border: "1px solid #ddd",
//                   fontSize: "12px",
//                   backgroundColor: "#fff"
//                 }}
//               />
//               <motion.button
//                 whileTap={{ scale: 0.9 }}
//                 onClick={() => {
//                   navigator.clipboard.writeText(referralLink);
//                   alert("Referral link copied ✅");
//                 }}
//                 style={{
//                   backgroundColor: "#5dc5fa",
//                   color: "#fff",
//                   border: "none",
//                   padding: "8px 14px",
//                   borderRadius: "6px",
//                   fontSize: "12px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   whiteSpace: "nowrap"
//                 }}
//               >
//                 Copy
//               </motion.button>
//             </div>
//           </div>

//         {influencerRecord ? (
//           <motion.div
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3 }}
//             className="influencer-section"
//           >
//             <div className="influencer-header">
//               <div className="influencer-icon">⭐</div>
//               <div className="influencer-title">
//                 Influencer Partner
//               </div>
//             </div>
            
//             <div className="influencer-grid">
//               <div className="influencer-item">
//                 <div className="influencer-label">
//                   Active Since
//                 </div>
//                 <div className="influencer-value">
//                   {new Date(influencerRecord.start_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
//                 </div>
//               </div>
              
//               <div className="influencer-item">
//                 <div className="influencer-label">
//                   Valid Until
//                 </div>
//                 <div className="influencer-value">
//                   {new Date(influencerRecord.end_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
//                 </div>
//               </div>
//             </div>

//             <div className="influencer-benefit">
//               <div className="influencer-label">
//                 Your Referral Benefit
//               </div>
//               <div className="benefit-percentage">
//                 {parseFloat(influencerRecord.benefit_percentage).toFixed(2).replace(/\.00$/, '')}%
//               </div>
//               <div className="benefit-description">
//                 You will receive <strong>{parseFloat(influencerRecord.benefit_percentage).toFixed(2).replace(/\.00$/, '')}% commission</strong> on every order placed by users through your referral link.
//               </div>
//             </div>
//           </motion.div>
//         ) : null}

//         <form onSubmit={handleSubmit} className="profile-form">
//           {[
//             { label: "Name", value: name, setter: setName, type: "text" },
//             { label: "Email", value: email, setter: setEmail, type: "email" },
//             { label: "Phone", value: phone, setter: setPhone, type: "text", disabled: true },
//             { label: "Location", value: location, setter: setLocation, type: "text" },
//           ].map((field) => (
//             <motion.div
//               key={field.label}
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.3 }}
//               className="form-group"
//             >
//               <label className="form-label">
//                 {field.label}:
//               </label>
//               <input
//                 type={field.type}
//                 value={field.value}
//                 disabled={field.disabled}
//                 onChange={(e) => field.setter(e.target.value)}
//                 className="form-input"
//               />
//             </motion.div>
//           ))}

//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.3 }}
//             className="form-group"
//           >
//             <label className="form-label">
//               Profile Picture:
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => setProfileImage(e.target.files[0])}
//               className="form-input"
//             />
//           </motion.div>

//           <motion.button
//             whileHover={{ scale: 1.05, backgroundColor: "#5dc5fa" }}
//             whileTap={{ scale: 0.95 }}
//             type="submit"
//             className="copy-button"
//             style={{ width: "100%", padding: "12px", fontSize: "1rem" }}
//           >
//             Save
//           </motion.button>
//         </form>
//       </motion.div>
//     </div>
//   );
// };

// export default MyProfile;

import React, { useState, useEffect, useRef } from "react";
import Api from "../Utills/Api";
import { motion } from "framer-motion";
import { QRCodeCanvas } from "qrcode.react";
import "./Profile.css";

// Helper function to get initials from name
const getInitials = (name) => {
  if (!name) return "?";
  const nameParts = name.trim().split(" ");
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};

// Helper function to generate a consistent color based on name
const getColorFromName = (name) => {
  if (!name) return "#6366f1";
  
  const colors = [
    "#6366f1", // Indigo
    "#8b5cf6", // Violet
    "#ec489a", // Pink
    "#f43f5e", // Rose
    "#ef4444", // Red
    "#5dc5fa", // Orange
    "#f59e0b", // Amber
    "#84cc16", // Lime
    "#10b981", // Emerald
    "#14b8a6", // Teal
    "#06b6d4", // Cyan
    "#3b82f6", // Blue
  ];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash = hash & hash;
  }
  return colors[Math.abs(hash) % colors.length];
};

const MyProfile = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [photo, setPhoto] = useState("");
  const [imageError, setImageError] = useState(false);
  const [influencerRecord, setInfluencerRecord] = useState(null);
  const referral_code = localStorage.getItem("referral_code");
  const referralLink = referral_code
  ? ` https://frozenwala.com/signup?referral_code=${referral_code}`
  : "No referral code assigned";
  const qrCodeUrl = "https://play.google.com/store/apps/details?id=com.frozenwala.app&pcampaignid=web_share";
  const qrCanvasRef = useRef(null);

  useEffect(() => {
    const getProfile = async () => {
      const uid = localStorage.getItem("user_id");

      try {
        const response = await Api.get(`api/profile/?user_id=${uid}`);
        //  localStorage.setItem("wallet", response.data.walet);
        setPhoto(response.data.profile_photo);
        setEmail(response.data.email);
        setName(response.data.name);
        setPhone(response.data.phone_number);
        setLocation(response.data.bio);
        setInfluencerRecord(response.data.influencer_record || null);
      } catch (error) {
        console.log("Error fetching profile:", error);
      }
    };
    getProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const uid = localStorage.getItem("user_id");
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("user_id", uid);
      formData.append("email", email);
      formData.append("phone_number", phone);
      formData.append("bio", location);
      if (profileImage) formData.append("profile_photo", profileImage);

      const response = await Api.post(`api/profile/`, formData);
      console.log("Profile updated:", response.data);
      window.location.reload();
    } catch (error) {
      console.log("Error updating profile:", error.response?.data);
    }
  };

  const downloadQRCode = () => {
    if (!qrCodeUrl) return;

    const canvas = qrCanvasRef.current.querySelector("canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "frozenwala-app-qr.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // Render profile image or initials
  const renderProfileImage = () => {
    // Check if there's a newly selected profile image
    if (profileImage) {
      return (
        <img
          src={URL.createObjectURL(profileImage)}
          alt="Profile"
          className="profile-image"
        />
      );
    }
    
    // Check if there's an existing photo from API and no error loading it
    if (photo && !imageError) {
      return (
        <img
          src={photo}
          alt="Profile"
          className="profile-image"
          onError={() => setImageError(true)}
        />
      );
    }
    
    // Fallback to initials avatar
    const initials = getInitials(name);
    const backgroundColor = getColorFromName(name);
    
    return (
      <div 
        className="profile-initials-avatar"
        style={{
          backgroundColor: backgroundColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          fontSize: "48px",
          fontWeight: "600",
          color: "white",
          margin: "0 auto",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)"
        }}
      >
        {initials}
      </div>
    );
  };

  return (
    <div className="my-profile-container">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="my-profile-card"
      >
        <h2 className="my-profile-title">
          My Profile
        </h2>

        <div className="profile-image-container">
          {renderProfileImage()}
        </div>
        
        {/* Download & Share Section */}
        {qrCodeUrl && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              marginTop: "30px",
              marginBottom: "30px",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
              border: "1px solid #f0f0f0",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              alignItems: "center"
            }}
          >
            {/* Left Side - Information */}
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px"
            }}>
              {/* Referral Code Section */}
              <div style={{
                padding: "14px 16px",
                backgroundColor: "#f8f8f8",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                border: "1px solid #e8e8e8"
              }}>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  flex: 1
                }}>
                  <span style={{
                    fontSize: "12px",
                    color: "#999",
                    fontWeight: "500",
                    marginBottom: "4px"
                  }}>
                    Your Referral Code
                  </span>
                  <span style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#333",
                    letterSpacing: "1px"
                  }}>
                    {referral_code || "REF000000"}
                  </span>
                </div>
                <motion.button
                  whileTap={{ scale: 0.9 }}
                  onClick={() => {
                    navigator.clipboard.writeText(referral_code || "REF000000");
                    alert("Referral code copied ✅");
                  }}
                  style={{
                    backgroundColor: "#5dc5fa",
                    color: "#fff",
                    border: "none",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    flexShrink: 0,
                    minWidth: "45px"
                  }}
                >
                  📋
                </motion.button>
              </div>

              {/* Download Options */}
              <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: "10px"
              }}>
                <a
                  href="https://frozenwala.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    padding: "12px",
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    width: "100px",
                    height: "100px",
                    overflow: "hidden"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#eee";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <span style={{ fontSize: "24px" }}>🌐</span>
                  <span style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#333"
                  }}>
                    Website
                  </span>
                </a>
                <a
                  href="https://apps.apple.com/app/frozenwala"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    padding: "12px",
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    width: "100px",
                    height: "100px",
                    overflow: "hidden"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#eee";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <span style={{ fontSize: "24px" }}>🍎</span>
                  <span style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#333"
                  }}>
                    iOS App
                  </span>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.frozenwala.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    padding: "12px",
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    width: "100px",
                    height: "100px",
                    overflow: "hidden"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#eee";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <span style={{ fontSize: "24px" }}>🤖</span>
                  <span style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#333"
                  }}>
                    Android App
                  </span>
                </a>
              </div>
            </div>

            {/* Right Side - QR Code (Centered Vertically) */}
            <motion.div
              ref={qrCanvasRef}
              whileHover={{ scale: 1.05 }}
              style={{
                borderRadius: "12px",
                padding: "12px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden"
              }}
            >
              <QRCodeCanvas
                value={qrCodeUrl}
                size={200}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
              />
            </motion.div>
          </motion.div>

        )}
          <motion.button
            whileHover={{ scale: 1.02, boxShadow: "0 6px 24px rgba(255, 152, 0, 0.4)" }}
            whileTap={{ scale: 0.95 }}
            onClick={downloadQRCode}
            style={{
              backgroundColor: "#e41f26",
              color: "#fff",
              border: "none",
              padding: "14px 28px",
              borderRadius: "12px",
              fontWeight: "700",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
              transition: "all 0.3s ease",
              width: "100%",
              gridColumn: "1 / -1"
            }}
          >
            🛒 Download & Order Now
          </motion.button>

          {/* Referral Link Display */}
          <div style={{
            padding: "12px 14px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
            gridColumn: "1 / -1"
          }}>
            <div style={{
              fontSize: "11px",
              color: "#999",
              marginBottom: "6px",
              fontWeight: "500"
            }}>
              Your Referral Link:
            </div>
            <div style={{
              display: "flex",
              gap: "8px",
              alignItems: "stretch"
            }}>
              <input
                type="text"
                value={referralLink}
                readOnly
                style={{
                  flex: 1,
                  padding: "8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "12px",
                  backgroundColor: "#fff"
                }}
              />
              <motion.button
                whileTap={{ scale: 0.9 }}
                onClick={() => {
                  navigator.clipboard.writeText(referralLink);
                  alert("Referral link copied ✅");
                }}
                style={{
                  backgroundColor: "#5dc5fa",
                  color: "#fff",
                  border: "none",
                  padding: "8px 14px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                Copy
              </motion.button>
            </div>
          </div>

        {influencerRecord ? (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="influencer-section"
          >
            <div className="influencer-header">
              <div className="influencer-icon">⭐</div>
              <div className="influencer-title">
                Influencer Partner
              </div>
            </div>
            
            <div className="influencer-grid">
              <div className="influencer-item">
                <div className="influencer-label">
                  Active Since
                </div>
                <div className="influencer-value">
                  {new Date(influencerRecord.start_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                </div>
              </div>
              
              <div className="influencer-item">
                <div className="influencer-label">
                  Valid Until
                </div>
                <div className="influencer-value">
                  {new Date(influencerRecord.end_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                </div>
              </div>
            </div>

            <div className="influencer-benefit">
              <div className="influencer-label">
                Your Referral Benefit
              </div>
              <div className="benefit-percentage">
                {parseFloat(influencerRecord.benefit_percentage).toFixed(2).replace(/\.00$/, '')}%
              </div>
              <div className="benefit-description">
                You will receive <strong>{parseFloat(influencerRecord.benefit_percentage).toFixed(2).replace(/\.00$/, '')}% commission</strong> on every order placed by users through your referral link.
              </div>
            </div>
          </motion.div>
        ) : null}

        <form onSubmit={handleSubmit} className="profile-form">
          {[
            { label: "Name", value: name, setter: setName, type: "text" },
            { label: "Email", value: email, setter: setEmail, type: "email" },
            { label: "Phone", value: phone, setter: setPhone, type: "text", disabled: true },
            { label: "Location", value: location, setter: setLocation, type: "text" },
          ].map((field) => (
            <motion.div
              key={field.label}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
              className="form-group"
            >
              <label className="form-label">
                {field.label}:
              </label>
              <input
                type={field.type}
                value={field.value}
                disabled={field.disabled}
                onChange={(e) => field.setter(e.target.value)}
                className="form-input"
              />
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
            className="form-group"
          >
            <label className="form-label">
              Profile Picture:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImage(e.target.files[0])}
              className="form-input"
            />
          </motion.div>

          <motion.button
            whileHover={{ scale: 1.05, backgroundColor: "#5dc5fa" }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="copy-button"
            style={{ width: "100%", padding: "12px", fontSize: "1rem" }}
          >
            Save
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default MyProfile;